import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useMutationNotifier } from '../../../../notifications/useMutationNotifier'
import { useOrgDashboardQuery } from '../../queries/orgDashboard_gen'
import {
  UpdateStripeCompanyAccountMutation,
  UpdateStripeCompanyAccountMutationVariables,
  useUpdateStripeCompanyAccountMutation,
} from './updateStripeCompanyAccount_gen'

type UseUpdateStripeCompanyAccountOptions = UseGqlMutationCallbacks<
  UpdateStripeCompanyAccountMutation,
  UpdateStripeCompanyAccountMutationVariables
>

export const useUpdateStripeCompanyAccount = (mutationOptions?: UseUpdateStripeCompanyAccountOptions) => {
  const { mutateAsync: updateStripeCompanyAccount } = useUpdateStripeCompanyAccountMutation()
  const optionsWithNotification = useMutationNotifier({}, mutationOptions)

  return useMutationWithInvalidation(updateStripeCompanyAccount, optionsWithNotification, [
    (_data: unknown, variables: UpdateStripeCompanyAccountMutationVariables) =>
      useOrgDashboardQuery.getKey({ orgId: variables.input.orgId }),
  ])
}
